import { render, staticRenderFns } from "./SexBody.vue?vue&type=template&id=1498808e&"
import script from "./SexBody.vue?vue&type=script&lang=js&"
export * from "./SexBody.vue?vue&type=script&lang=js&"
import style0 from "./SexBody.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports